import { defineStore } from 'pinia';
import { ref, watch } from 'vue';

export const useThemeStore = defineStore('theme', () => {
  const isDarkMode = ref(localStorage.getItem('isDarkMode') === 'true' || false);
  const primaryColor = ref(localStorage.getItem('primaryColor') || 'rose'); // Default color

  const availableColors = [
    { name: 'rose', hex: '#f43f5e' }, // #bb0427 is not a standard tailwind color, using rose-500
    { name: 'blue', hex: '#3B82F6' },
    { name: 'green', hex: '#22C55E' },
    { name: 'orange', hex: '#F97316' },
    { name: 'purple', hex: '#8B5CF6' },
  ];

  watch(isDarkMode, (newVal) => {
    localStorage.setItem('isDarkMode', newVal);
  });

  watch(primaryColor, (newVal) => {
    localStorage.setItem('primaryColor', newVal);
  });

  function toggleDarkMode() {
    isDarkMode.value = !isDarkMode.value;
  }

  function setColor(newColorName) {
    primaryColor.value = newColorName;
  }

  return { isDarkMode, primaryColor, availableColors, toggleDarkMode, setColor };
});
